import { render, staticRenderFns } from "./CarManage.vue?vue&type=template&id=b6ca4e3a&scoped=true&"
import script from "./CarManage.vue?vue&type=script&lang=js&"
export * from "./CarManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ca4e3a",
  null
  
)

component.options.__file = "CarManage.vue"
export default component.exports